import { useCallback } from 'react';
import styled from 'styled-components';
import AssignToTeamHeaderHD from '../components/AssignToTeamHeaderHD';
import AssignToUserHeaderHD from '../components/AssignToUserHeaderHD';
// @ts-expect-error Not a TS file
import SearchMoreLabel from '../components/SearchMoreLabel';
import TeamOption from '../components/TeamOption';
import UnassignButtonOptionHD from '../components/UnassignButtonOptionHD';
import UserOptionHD from '../components/UserOptionHD';
import { ASSIGN_TO_TEAM_SECTION, ASSIGN_TO_USER_SECTION, SEARCH_MORE_OPTION, UNASSIGN_OPTION } from '../constants/reassignment-dropdown';
import { checkIsTeamAssignee, checkIsUserAssignee } from '../utils/assignee-options';
import { jsx as _jsx } from "react/jsx-runtime";
const TeamOptionContainer = styled.div.withConfig({
  displayName: "useAssignmentOptionRenderer__TeamOptionContainer",
  componentId: "r5ic0k-0"
})(["padding-left:14px;"]);
const renderAssignee = (option, currentUserId, currentAssigneeId, isUngatedForWorkingHours, isUngatedForHelpDeskRoutingScopeFiltering) => {
  if (checkIsTeamAssignee(option)) {
    return /*#__PURE__*/_jsx(TeamOptionContainer, {
      children: /*#__PURE__*/_jsx(TeamOption, {
        option: option,
        isUngatedForHelpDeskRoutingScopeFiltering: isUngatedForHelpDeskRoutingScopeFiltering
      })
    });
  }
  if (checkIsUserAssignee(option)) {
    return /*#__PURE__*/_jsx(UserOptionHD, {
      currentAssigneeId: currentAssigneeId,
      currentUserId: currentUserId,
      option: option,
      isUngatedForWorkingHours: isUngatedForWorkingHours
    });
  }
  return null;
};
export const useAssignmentOptionRendererHD = ({
  canRouteToAvailable,
  currentAssigneeId,
  currentUserId,
  handleUnassign,
  workspaceId,
  isUngatedForWorkingHours,
  isUngatedForHelpDeskRoutingScopeFiltering
}) => useCallback(option => {
  if (!option) {
    return null;
  }

  // we do this because user & team options don't have a section ID but
  // are run through this function
  switch (option.sectionId) {
    case UNASSIGN_OPTION:
      return /*#__PURE__*/_jsx(UnassignButtonOptionHD, {
        currentAssigneeId: currentAssigneeId,
        onClick: handleUnassign
      });
    case ASSIGN_TO_TEAM_SECTION:
      return /*#__PURE__*/_jsx(AssignToTeamHeaderHD, {
        canRouteToAvailable: canRouteToAvailable,
        isUngatedForHelpDeskRoutingScopeFiltering: isUngatedForHelpDeskRoutingScopeFiltering
      });
    case ASSIGN_TO_USER_SECTION:
      return /*#__PURE__*/_jsx(AssignToUserHeaderHD, {
        isUngatedForHelpDeskRoutingScopeFiltering: isUngatedForHelpDeskRoutingScopeFiltering,
        workspaceId: workspaceId
      });
    case SEARCH_MORE_OPTION:
      return /*#__PURE__*/_jsx(SearchMoreLabel, {});
    default:
      return renderAssignee(option, currentUserId, currentAssigneeId, isUngatedForWorkingHours, isUngatedForHelpDeskRoutingScopeFiltering);
  }
}, [canRouteToAvailable, currentAssigneeId, currentUserId, handleUnassign, workspaceId, isUngatedForWorkingHours, isUngatedForHelpDeskRoutingScopeFiltering]);